import i18next from "i18next";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { PaginatorTemplate } from "primereact/paginator";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../../App";
import left from "../../assets/images/left.svg";
import right from "../../assets/images/right.svg";
import getEnv, { getGA } from "../../utils/getAppEnv";
import getImageBaseUrl from "../../utils/getImageBaseUrl";
import Email, { EMAIL_TYPE } from "../Email/Email";
import "./MountListView.css";
export interface Mount {
  id: number;
  mountName: string;
  partNumber: string;
  minStaticLoadKg: string;
  maxStaticLoadKg: string;
  drawingNum: string;
  hardnessValue: string;
  staticStiffness: string;
  dynamicStiffness: string;
  deflection: number;
  naturalFrequency: number;
  isolation: number;
  mountImgURL: string;
  technicalImgURL: string;
  cadDrawingURL: string;
}

const DEFAULT_IMG =
  "http://mountfinder.trelleborg.com/content/mountsvgs/d2bf8eb6-0269-47cc-aaa4-ab83da29bd90.png";
interface Props {
  values: Array<Mount>;
  columns: Array<{ label: string; value: string; sortable?: boolean }>;
  rpm?: string;
  kg?: string;
  noOfMount?: string;
  currentCategory: string;
  failSafe: boolean;
}

const MountListView: React.FC<Props> = ({
  values,
  columns,
  currentCategory,
  failSafe,
  rpm,
  kg,
  noOfMount,
}) => {
  const ref = useRef<any>(null);
  const { t } = useTranslation();
  const [selectedMounts, setSelectedMounts] = useState<Array<Mount>>([]);
  const navigate = useNavigate();
  const ctx = useContext(GlobalContext);
  const [page, setPage] = useState(0);
  const [records, setRecords] = useState(0);
  const [scrollVisible, setScrollVisible] = useState(false);
  const [isMobileView, setMobileView] = useState(
    window.innerWidth < 425 ? true : false
  );
  useEffect(() => {
    setSelectedMounts([]);
  }, [ctx.failSafe]);
  window.addEventListener("resize", (ev) => {
    if (window.innerWidth < 425) {
      setMobileView(true);
    } else {
      setMobileView(false);
    }
  });
  useEffect(() => {
    if (
      ctx.multiSortMeta.sortField &&
      ctx.multiSortMeta.sortOrder &&
      columns.find((col) => col.value === ctx.multiSortMeta.sortField)
    ) {
      ref.current.state.sortField = ctx.multiSortMeta.sortField;
      ref.current.state.sortOrder = ctx.multiSortMeta.sortOrder;
    }
  }, []);
  const template: PaginatorTemplate = {
    layout: isMobileView
      ? "RowsPerPageDropdown PrevPageLink PageLinks NextPageLink CurrentPageReport"
      : "RowsPerPageDropdown  PrevPageLink  FirstPageLink PageLinks LastPageLink NextPageLink CurrentPageReport",
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 50, value: 50 },
        { label: 100, value: 100 },
        { label: 150, value: 150 },
      ];

      return (
        <Dropdown
          value={options.value}
          options={dropdownOptions}
          onChange={options.onChange}
        />
      );
    },
    FirstPageLink: (options) => {
      if (ref.current && ref.current.state) {
        return (
          <button
            className={`${options.className} ${
              ref.current.state.first === 0 ? "page-active-class" : ""
            }`}
            onClick={options.onClick}
          >
            1
          </button>
        );
      }
      return "";
    },
    PrevPageLink: (options) => {
      return (
        <button
          type="button"
          className={`${options.className} mr-4`}
          onClick={options.onClick}
          disabled={options.disabled}
          title={t("PREV")}
        >
          <span className="p-3">
            <img src={left} alt={t("PREV")} />
          </span>
        </button>
      );
    },
    NextPageLink: (options) => {
      return (
        <button
          type="button"
          className={`${options.className} ml-4`}
          onClick={options.onClick}
          disabled={options.disabled}
          title={t("NEXT")}
        >
          <span className="p-3">
            <img src={right} alt={t("NEXT")} />
          </span>
        </button>
      );
    },
    PageLinks: (options) => {
      if (
        !isMobileView &&
        ((options.view.startPage === options.page &&
          options.view.startPage !== 0) ||
          (options.view.endPage === options.page &&
            options.page + 1 !== options.totalPages))
      ) {
        return "";
      }
      if (
        !isMobileView &&
        (options.page === 0 || options.page + 1 === options.totalPages)
      ) {
        return;
      }
      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
        >
          {options.page + 1}
        </button>
      );
    },
    LastPageLink: (options) => {
      if (ref.current && ref.current.props.value) {
        const lastPage = page;
        if (lastPage === 1 || lastPage === 0) {
          return "";
        }
        const currentPage =
          ref.current.state.first / ref.current.state.rows + 1;
        return (
          <button
            className={`${options.className} ${
              currentPage === lastPage ? "page-active-class" : ""
            }`}
            onClick={options.onClick}
          >
            {ref.current && ref.current.props.value ? lastPage : ">>"}
          </button>
        );
      }
      return "";
    },
    CurrentPageReport: (options) => {
      setTimeout(() => {
        setPage(options.totalPages);
        setRecords(options.totalRecords);
        setScrollVisible(
          (options.currentPage !== options.totalPages &&
            options.totalRecords / (options.totalPages * options.rows) < 5) ||
            (options.currentPage === options.totalPages &&
              options.currentPage * options.rows - options.totalRecords < 4) ||
            (options.currentPage === options.totalPages &&
              options.currentPage * options.rows - options.totalRecords > 4)
        );
      }, 0);
      return "";
    },
    JumpToPageInput: () => {},
  };
  const isInputDataAvailable = () => {
    if (kg && rpm && noOfMount) {
      return true;
    }
    return false;
  };

  const handleClick = (op: any) => {
    ctx.updateGlobalCtx({
      ...ctx,
      currentView: "LIST",
      currentCategory: currentCategory,
      rpm: rpm,
      failSafe,
      kg: kg,
      noOfMount: noOfMount,
      results: isInputDataAvailable() ? values : [],
      multiSortMeta: {
        sortField: ref.current.state.sortField,
        sortOrder: ref.current.state.sortOrder,
      },
    });
    const url = isInputDataAvailable()
      ? `/mount/${op.partNumber}?rpm=${rpm}&kg=${kg}&noOfMount=${noOfMount}`
      : `/mount/${op.partNumber}`;

    (window as any).dataLayer.push({
      event: "engagement",
      eventCategory: "Mountfinder Category",
      eventAction: "Specific Mount", // 'Weight of the Machine', 'Machine Speed', 'Number of Mounts' and 'Category'
      eventLabel: op.mountName,
    });

    navigate(url);
  };
  return (
    <div
      className={`${
        records < 4 || !scrollVisible ? "disable-scroll" : ""
      } table`}
    >
      <DataTable
        ref={ref}
        dataKey="id"
        value={values}
        selectionMode="checkbox"
        stripedRows
        paginator
        responsiveLayout="scroll"
        paginatorTemplate={template}
        filterDisplay="row"
        sortField="isolation"
        pageLinkSize={isMobileView ? 1 : 5}
        sortOrder={-1}
        paginatorRight={
          <Email
            hasSelectedMount={selectedMounts.length === 0}
            label="EMAIL_RES"
            details={{
              partNumberList: selectedMounts.map((m) => m.partNumber),
              machinWeight: kg,
              numOfMount: noOfMount,
              rpmValue: rpm,
              failSafe: failSafe,
            }}
            type={
              kg && noOfMount && rpm
                ? EMAIL_TYPE.AVS_MOUNT_LIST
                : EMAIL_TYPE.CATALOGUE_MOUNT_LIST
            }
          />
        }
        selection={selectedMounts}
        onSelectionChange={(e) => setSelectedMounts(e.value)}
        emptyMessage={[
          t("MOUNT_NOT_FOUND"),
          ". ",
          <Trans
            i18nKey={"CONTACT_FURTHER"}
            components={[
              <a
                className="link"
                href={`mailto:TIAVS.Design.Enquiries@trelleborg.com`}
                target={"_blank"}
              ></a>,
            ]}
          ></Trans>,
        ]}
        rows={50}
        rowsPerPageOptions={[50, 100, 150]}
      >
        <Column key="asd" selectionMode="multiple"></Column>
        {columns.map((col, id) => (
          <Column
            key={id}
            field={col.value}
            header={t(col.label)}
            sortable={col.sortable}
            filter
            body={(option) =>
              col.value === "mountName" ? (
                <div
                  className="flex align-items-center cursor-pointer"
                  onClick={() => handleClick(option)}
                >
                  <img
                    width={50}
                    height={50}
                    loading="lazy"
                    src={
                      option.mountImgURL
                        ? getImageBaseUrl() + option.mountImgURL
                        : DEFAULT_IMG
                    }
                    alt={option.mountName}
                  />{" "}
                  <div className="ml-3 font-semibold text-image">
                    {option.mountName}
                  </div>
                </div>
              ) : (
                <div>
                  {Number(option[col.value]) &&
                  col.label !== "PART_NO" &&
                  col.label !== "HARDNESS_WITH_UNIT"
                    ? Number(option[col.value]).toFixed(1)
                    : option[col.value]}
                </div>
              )
            }
            filterMatchMode="contains"
            showFilterMenu={false}
            showClearButton={false}
          ></Column>
        ))}
      </DataTable>
    </div>
  );
};

export default MountListView;
